<template>
	<button
		:class="['tag-card', { 'tag-card--child': variant === 'child', 'tag-card--pro': pro }]"
		:style="`order: ${sort}`"
	>
		<img v-if="icon_url" class="tag-card-icon" width="16" height="21" :src="icon_url" :alt="`Иконка для ${name}`" />
		<p class="tag-card-name">{{ name }}</p>
	</button>
</template>

<script setup lang="ts">
defineProps({
	name: { type: String, required: true },
	icon_url: { type: String },
	sort: { type: Number, default: 0 },
	variant: { type: String, default: 'default' },
	// Отдельно от variant: дочерний топик внутри группы может быть одновременно child и pro.
	pro: { type: Boolean, default: false }
})
</script>

<style lang="scss" scoped>
.tag-card {
	padding: 8px 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	background-color: var(--background-tile);
	box-shadow: var(--shadow-tile);
	border-radius: var(--radius-md);
	font: var(--font-label);
	color: var(--text-primary);
	cursor: pointer;
	transition: $transition-color, $transition-bg;
	&-icon {
		margin-right: 8px;
		object-fit: contain;
	}
	&:hover {
		color: var(--icon-hover);
		background: var(--background-secondary-hover);
	}
	&:active {
		color: var(--text-primary);
		background: var(--background-brand-subtle);
	}
	&--child {
		background-color: var(--selection-rest);
		color: var(--text-brand);
		@if $is-mts {
			font-weight: 700;
		}
	}
	// Платный топик. Идёт после --child, чтобы перебивать и его, и MTS-ветку.
	// background (шорткат) сбрасывает background-color из базы и из @if $is-mts.
	&--pro {
		background: var(--gradient-pro);
		color: var(--text-inverse);
		// .tag-card:hover/:active меняют color — здесь держим белый во всех состояниях.
		&:hover {
			color: var(--text-inverse);
			background: var(--gradient-pro);
			filter: brightness(1.06);
		}
		&:active {
			color: var(--text-inverse);
			background: var(--gradient-pro);
			filter: brightness(0.95);
		}
	}
}
</style>
